// NOTE: van 生产环境为 prod
export const env =
  process.env.NODE_ENV === 'development'
    ? 'dev'
    : document.documentElement.dataset.vanEnv || 'prod';

export const isProd = env === 'prod';

export const API_HOST = {
  dev: '/index.php',
  stg: 'https://survey-gt-api-stg.xiaolachuxing.com',
  pre: 'https://survey-gt-api-pre.xiaolachuxing.com',
  prod: 'https://survey-gt-api.xiaolachuxing.com',
}[env];

export const SA_API_HOST = {
  stg: 'https://uba-dev.xiaolachuxing.com/sa?project=production',
  pre: 'https://uba-dev.xiaolachuxing.com/sa?project=production',
  prod: 'https://uba.xiaolachuxing.com/sa?project=production',
}[env];

const dommainKeyMap = {
  dev: '-stg',
  stg: '-stg',
  pre: '-pre',
  prod: '',
};

export const envType = dommainKeyMap[env];
